import { FunctionComponent } from 'react';
import { Div, Headline, BodyText, Button } from '@gaiads/telia-react-component-library';
import { useDispatch } from 'react-redux';

import * as actions from './../../../store/actions';

interface LoginNoAccessProps {
  title: string;
  contentBodyText: string;
  instructionBodyText: string;
  logoutButtonLabel: string;
}

const LoginNoAccess: FunctionComponent<LoginNoAccessProps> = ({ title, contentBodyText, instructionBodyText, logoutButtonLabel }) => {
  const dispatch = useDispatch();

  const handleLogout = () => dispatch(actions.executeLogout());

  return (
    <Div padding={{ top: 'xxlg', horizontal: 'xxlg' }}>
      <Headline size="md" block>
        {title}
      </Headline>
      <BodyText margin={{ top: 'xlg', bottom: 'sm' }} padding={{ top: 'md' }} color="gray800">
        {contentBodyText}
      </BodyText>
      <BodyText margin={{ bottom: 'xlg' }} color="gray800">
        {instructionBodyText}
      </BodyText>
      <Button variant="secondary" size="lg" onClick={handleLogout}>
        {logoutButtonLabel}
      </Button>
    </Div>
  );
};

export default LoginNoAccess;
